import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ApplicantDetails } from './applicant-details';
import { ApplicantSearch } from './applicant-search';
import { Helmet } from 'react-helmet';

export const Applicant: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Applicant</title>
      </Helmet>
      <Routes>
        <Route path="/:applicantId/applicant-details/*" element={<ApplicantDetails />} />
        <Route path="*" element={<ApplicantSearch />} />
      </Routes>
    </>
  );
};
